const gradients = {
  midnight: 'Midnight',
  dusk: 'Dusk',
  atmosphere: 'Atmosphere',
  space: 'Space',
  horizon: 'Horizon',
  sea: 'Sea',
  arctic: 'Arctic',
}

export default gradients
